import messages from './CA7Tooltip.message';

const Tooltips = {
    CA7BusinessAutoEnhancement_Ext : messages.CA7BusinessAutoEnhancement_Ext,
    CA7BusinessAutoEnEdgeEn_Ext: messages.CA7BusinessAutoEnEdgeEn_Ext,
}

export default Tooltips